export const appHead = {"meta":[{"charset":"utf-8"},{"name":"description","content":"키보드 타자가 현금으로 전환! 만보기보다 쉽고 빠르게 돈을 벌어보세요."},{"name":"viewport","content":"width=device-width, height=device-height, initial-scale=1, maximum-scale=1, target-densityDpi=device-dpi, user-scalable=no"},{"property":"og:title","content":"키보드만 써도 포인트 주는 플레이키보드"},{"property":"og:description","content":"키보드 타자가 현금으로 전환! 만보기보다 쉽고 빠르게 돈을 벌어보세요."},{"property":"og:image","content":"https://playkeyboard.s3.ap-northeast-2.amazonaws.com/event/share-img.png"},{"property":"og:url","content":"https://webview.plkey.app/event/WHATS_NEW-ARKNIGHTS-KO"}],"link":[{"rel":"icon","type":"image/png","href":"/favicon.png"}],"style":[],"script":[{"type":"text/javascript","innerHTML":"window.receiveUserToken = function (token) {\n    console.log(token);\n    localStorage.setItem(\"token\", token);\n};"}],"noscript":[],"title":"PlayKeyboard","htmlAttrs":{"lang":"ko"}}

export const appBaseURL = "/"

export const appBuildAssetsDir = "/_nuxt/"

export const appCdnURL = ""

export const appLayoutTransition = false

export const appPageTransition = false

export const appViewTransition = false

export const appKeepalive = false

export const appRootId = "__nuxt"

export const appRootTag = "div"

export const appRootAttrs = {"id":"__nuxt"}

export const appTeleportTag = "div"

export const appTeleportId = "teleports"

export const appTeleportAttrs = {"id":"teleports"}

export const appSpaLoaderTag = "div"

export const appSpaLoaderAttrs = {"id":"__nuxt-loader"}

export const renderJsonPayloads = true

export const componentIslands = false

export const payloadExtraction = false

export const cookieStore = true

export const appManifest = true

export const remoteComponentIslands = false

export const selectiveClient = false

export const devPagesDir = null

export const devRootDir = null

export const devLogs = false

export const nuxtLinkDefaults = {"componentName":"NuxtLink","prefetch":true,"prefetchOn":{"visibility":true}}

export const asyncDataDefaults = {"value":null,"errorValue":null,"deep":true}

export const resetAsyncDataToUndefined = true

export const nuxtDefaultErrorValue = null

export const fetchDefaults = {}

export const vueAppRootContainer = '#__nuxt'

export const viewTransition = false

export const appId = "nuxt-app"

export const outdatedBuildInterval = 3600000

export const multiApp = false

export const chunkErrorEvent = "vite:preloadError"

export const crawlLinks = true

export const spaLoadingTemplateOutside = false

export const purgeCachedData = true

export const granularCachedData = false

export const pendingWhenIdle = true

export const alwaysRunFetchOnKeyChange = true